import { render, staticRenderFns } from "./ModalPicture.vue?vue&type=template&id=ef00884c&scoped=true&"
import script from "./ModalPicture.vue?vue&type=script&lang=js&"
export * from "./ModalPicture.vue?vue&type=script&lang=js&"
import style0 from "./ModalPicture.vue?vue&type=style&index=0&id=ef00884c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef00884c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
